
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34970',
  depVersions: {
  "documents-public-ui": "static-1.34970",
  "atom": "static-1.5247",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2671",
  "client-types": "static-1.488",
  "cssUtils": "static-1.842",
  "customer-data-filters-ui": "static-1.40448",
  "customer-data-objects": "static-1.7851",
  "customer-data-property-utils": "static-1.8267",
  "documents-lib": "static-1.34975",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.352",
  "FormsCommonComponents": "static-1.86310",
  "FormUrlGenerator": "static-2.4893",
  "foundations-theming-specialty": "static-1.2327",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5766",
  "hs-test-utils": "static-1.8194",
  "hub-http": "static-1.6392",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11956",
  "HubStyleTokens": "static-2.11649",
  "I18n": "static-7.1645",
  "icons": "static-2.665",
  "jasmine-immutable": "static-1.3195",
  "jasmine-runner": "static-1.6627",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7323",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5565",
  "quartz": "static-1.7257",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5465",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8347",
  "reference-resolvers-lite": "static-1.8269",
  "reporting-data": "static-1.68240",
  "reporting-reports": "static-1.67918",
  "reporting-snowflake": "static-1.56858",
  "reporting-testing-lib": "static-1.10173",
  "reporting-visualizations": "static-1.60316",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9121",
  "sanitize": "static-1.4648",
  "sanitize-text": "static-1.8318",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1916",
  "signup-constants": "static-1.19302",
  "signup-ui-url-generator": "static-2.8230",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4930",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4930",
  "ui-addon-form-validation": "static-1.11161",
  "ui-asset-management-lib": "static-1.11253",
  "ui-images": "static-2.1205",
  "UIComponents": "static-3.8595",
  "usage-tracker": "static-1.7524",
  "usage-tracker-container": "static-1.7514",
  "usage-tracker-core": "static-1.7374",
  "viral-links-lib": "static-1.7243",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9830",
  "foundations-components": "static-1.8271",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1035",
  "quartz-core": "static-1.6476",
  "quick-fetch": "static-1.4041",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4830",
  "ui-addon-i18n": "static-1.11320",
  "ui-addon-upgrades": "static-9.18219",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3525",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3534",
  "quartz-webpack": "static-1.3481",
  "foundations-assets": "static-1.5045",
  "foundations-theming": "static-1.4611",
  "hub-http-shared-msw-handlers": "static-1.10393",
  "hubspotter-http": "static-1.4775",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7420",
  "crm-message-bus": "static-1.43481",
  "customer-data-filters-ui-msw-helpers": "static-1.22883",
  "customer-data-objects-ui-components": "static-1.13202",
  "customer-data-reference-ui-components": "static-1.13348",
  "customer-data-ui-utilities": "static-1.9996",
  "events-data-lib": "static-1.410",
  "framework-builder-read-service-client": "static-1.4130",
  "framework-data-schema-quick-fetch": "static-1.6971",
  "framework-data-schema-resolvers": "static-1.7066",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3712",
  "inbound-db-properties-service-client": "static-1.3970",
  "multi-account-reference-resolvers": "static-1.1155",
  "onboarding-tours": "static-1.16929",
  "reporting-datasets-permissions-lib": "static-1.14186",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2279",
  "trellis-components": "static-1.2298",
  "trellis-theming": "static-1.1120",
  "ui-addon-teams": "static-1.21766",
  "quartz-auth": "static-1.932",
  "ui-business-units-lib": "static-1.9251",
  "usage-tracker-session-replay": "static-1.5210",
  "ai-components-ui-library": "static-1.9396",
  "ContentUtils": "static-1.68882",
  "customer-data-properties": "static-1.52168",
  "forms-ai-lib": "static-1.4586",
  "forms-utils-lib": "static-1.12901",
  "foundations-components-test-utils": "static-1.5754",
  "react-dnd-compat": "static-1.4786",
  "react-tinymce": "static-1.55713",
  "tinymce-config": "static-2.54839",
  "ui-gdpr-components": "static-1.10521",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3596",
  "HeadJS": "static-2.777",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3305",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.205",
  "ui-fonts": "static-1.911",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4496",
  "csstype": "static-1.50",
  "quartz-head": "static-1.922",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1716",
  "external-options-client-types": "static-1.4250",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.932",
  "frontend-preferences-client": "static-1.8099",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3873",
  "reporting-client-types": "static-1.2600",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25906",
  "hubspot-apollo-client": "static-1.5050",
  "foundations-components-legacy": "static-1.1296",
  "quartz-routing": "static-1.687",
  "hs-story-utils": "static-1.9597",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.409",
  "timezone-utils": "static-2.5415",
  "seat-types-lib": "static-1.407",
  "react-create-root-preference": "static-1.45",
  "bend-plugin-foundations-components": "static-1.4540",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.932",
  "quartz-tracking": "static-1.636",
  "bend-plugin-chirp-manifest": "static-1.240",
  "chirp-fetch": "static-1.2060",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6168",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4204",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-foundations-theming": "static-1.3094",
  "restore-request-side-panel-lib": "static-1.1358",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.350",
  "pulse": "static-1.785",
  "conditional-properties-service-client": "static-1.3921",
  "crm-pipelines-api-client-types": "static-1.4262",
  "fdsr-migration-layer": "static-1.185",
  "multi-currency-client-types": "static-1.3816",
  "getting-started-shared-tasks": "static-1.18931",
  "growth-data-modal": "static-1.5713",
  "growth-onboarding-confetti": "static-1.3236",
  "growth-onboarding-next-action-utils": "static-1.2431",
  "navigation-components": "static-1.18492",
  "onboarding-tours-client": "static-1.5143",
  "onboarding-tours-utils": "static-1.995",
  "ui-shepherd-react": "static-3.10434",
  "ui-shepherd-tracker": "static-1.7815",
  "ui-universal-auth": "static-1.9182",
  "user-context": "static-1.5282",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10391",
  "magpie-lib": "static-1.5666",
  "navigation-messaging": "static-1.7819",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22179",
  "copilot-toolkit": "static-1.11581",
  "cms-field-types": "static-1.4987",
  "content-icons-ui": "static-1.2278",
  "integrations-lib": "static-1.16713",
  "calling-global-api": "static-1.65104",
  "calling-internal-common": "static-1.31485",
  "calling-lifecycle-internal": "static-1.66486",
  "calling-lifecycle-messages": "static-1.58780",
  "commerce-products-lib": "static-1.10212",
  "crm-links": "static-1.6486",
  "customer-data-properties-shared-msw-handlers": "static-1.9720",
  "file-manager-components": "static-1.24135",
  "formula-editor": "static-1.14563",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4341",
  "meetings-icalendar-utils-lib": "static-1.804",
  "object-builder-ui-client": "static-1.49315",
  "pipeline-validation-client-types": "static-1.4091",
  "property-value-citations": "static-1.2782",
  "smart-property-lib": "static-1.8052",
  "tiered-pricing": "static-1.1708",
  "topics-actions-lib": "static-1.320",
  "ui-addon-iframeable": "static-1.9248",
  "zustand": "static-1.74",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20132",
  "tinymce-themes": "static-1.56809",
  "data-token-picker": "static-1.16714",
  "hub-http-contrib": "static-1.3215",
  "interframe": "static-3.4927",
  "tinymce-data": "static-1.40924",
  "tinymce-plugins": "static-1.57953",
  "ui-addon-sales-email": "static-1.5384",
  "onboarding-scopes": "static-1.6630",
  "ui-addon-opt": "static-4.8533",
  "apollo-link-hub-http": "static-2.4823",
  "hubspot-apollo-cache": "static-1.509",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.345",
  "purchase-motions-api": "static-1.6171",
  "event-emitter": "static-1.1121",
  "bend-plugin-pulse": "static-1.288",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2261",
  "growth-onboarding-next-action-components": "static-1.2459",
  "user-context-client": "static-1.4722",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5126",
  "nest": "static-1.406",
  "reactive-lib": "static-1.896",
  "simple-logging-lib": "static-1.3221",
  "unified-auth-core-lib": "static-1.978",
  "getting-started-shared-tasks-store": "static-1.18049",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1339",
  "integrations-error-boundary-lib": "static-1.14128",
  "integrations-tracking-lib": "static-1.5778",
  "native-integrations-shared-strings": "static-1.7952",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10536",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.696",
  "calling-error-reporting": "static-1.31492",
  "shared-worker-versioning": "static-1.11208",
  "calling-usage-tracker": "static-1.6713",
  "voice-sms-access-library": "static-1.1626",
  "customer-data-tracking": "static-1.7057",
  "commerce-permissions": "static-1.947",
  "products-iframe-lib": "static-1.8355",
  "products-ui-components-shared-msw-handlers": "static-1.10775",
  "location-customization-utils-lib": "static-1.9773",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4320",
  "video-components-external": "static-1.11855",
  "video-data-lib": "static-1.35513",
  "bark-lib": "static-1.16654",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6059",
  "react-codemirror": "static-1.10804",
  "data-agent-kit": "static-1.469",
  "feedback-loader": "static-1.29621",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10476",
  "fsm": "static-1.3901",
  "policy-lib": "static-1.6957",
  "react-colorpicker": "static-2.10379",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10539",
  "FileManagerLib": "static-1.39775",
  "NamespacedHubStyle": "static-2.9175",
  "FileManagerCore": "static-1.39634",
  "content-assistance-lib": "static-1.8020",
  "layout-dnd-components": "static-1.12779",
  "layout-dnd-utils": "static-1.11754",
  "ui-addon-emoji-picker": "static-1.10056",
  "ui-brand-identity-lib": "static-1.15922",
  "InboxConnectUtils": "static-4.15286",
  "meetings-connect-utils-lib": "static-1.7779",
  "breeze-engine-core": "static-1.617",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3184",
  "adobe-sign-auth-lib": "static-1.194",
  "ads-unified-auth-lib": "static-1.682",
  "google-sheets-integration-lib": "static-1.759",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.210",
  "slack-ui-library": "static-1.10569",
  "calling-orchestration-schema": "static-1.36403",
  "sales-views-client-types": "static-1.4430",
  "crm-record-cards-service-types": "static-1.3709",
  "content-media-composition-data-lib": "static-1.12883",
  "content-media-compositions": "static-2.16890",
  "media-bridge-lib": "static-1.19229",
  "react-reducer-toolkit": "static-1.16085",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4679",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6176",
  "FileManagerImages": "static-1.37286",
  "video-components": "static-1.13857",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4704",
  "video-embed": "static-1.36347",
  "ui-addon-video-player": "static-1.8877",
  "ui-coaching-tips": "static-1.29051",
  "ContentData": "static-1.68957",
  "layout-data-lib": "static-1.10079",
  "social-insights-client-types": "static-1.22538",
  "outpost": "static-1.4340",
  "growth-onboarding-feedback-components": "static-1.6751",
  "advanced-menus-core": "static-1.15416",
  "advanced-menus-lib": "static-1.12313",
  "ExportDialog": "static-6.10550",
  "ui-memberships-settings-lib": "static-1.34526",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15415",
  "simple-menus-lib": "static-1.16932"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34970",
  "atom": "/atom/static-1.5247",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2671",
  "client-types": "/client-types/static-1.488",
  "cssUtils": "/cssUtils/static-1.842",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40448",
  "customer-data-objects": "/customer-data-objects/static-1.7851",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8267",
  "documents-lib": "/documents-lib/static-1.34975",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.352",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86310",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4893",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2327",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5766",
  "hs-test-utils": "/hs-test-utils/static-1.8194",
  "hub-http": "/hub-http/static-1.6392",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11956",
  "HubStyleTokens": "/HubStyleTokens/static-2.11649",
  "I18n": "/I18n/static-7.1645",
  "icons": "/icons/static-2.665",
  "jasmine-immutable": "/jasmine-immutable/static-1.3195",
  "jasmine-runner": "/jasmine-runner/static-1.6627",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7323",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5565",
  "quartz": "/quartz/static-1.7257",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-track-cwv-per-soft-navigation.19",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5465",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8347",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8269",
  "reporting-data": "/reporting-data/static-1.68240",
  "reporting-reports": "/reporting-reports/static-1.67918",
  "reporting-snowflake": "/reporting-snowflake/static-1.56858",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10173",
  "reporting-visualizations": "/reporting-visualizations/static-1.60316",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9121",
  "sanitize": "/sanitize/static-1.4648",
  "sanitize-text": "/sanitize-text/static-1.8318",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1916",
  "signup-constants": "/signup-constants/static-1.19302",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8230",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4930",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4930",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11161",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11253",
  "ui-images": "/ui-images/static-2.1205",
  "UIComponents": "/UIComponents/static-3.8595",
  "usage-tracker": "/usage-tracker/static-1.7524",
  "usage-tracker-container": "/usage-tracker-container/static-1.7514",
  "usage-tracker-core": "/usage-tracker-core/static-1.7374",
  "viral-links-lib": "/viral-links-lib/static-1.7243",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9830",
  "foundations-components": "/foundations-components/static-1.8271",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1035",
  "quartz-core": "/quartz-core/static-1.6476",
  "quick-fetch": "/quick-fetch/static-1.4041",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4830",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11320",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18219",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3525",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3534",
  "quartz-webpack": "/quartz-webpack/static-1.3481",
  "foundations-assets": "/foundations-assets/static-1.5045",
  "foundations-theming": "/foundations-theming/static-1.4611",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10393",
  "hubspotter-http": "/hubspotter-http/static-1.4775",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7420",
  "crm-message-bus": "/crm-message-bus/static-1.43481",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22883",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13202",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13348",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9996",
  "events-data-lib": "/events-data-lib/static-1.410",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4130",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6971",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7066",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3712",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3970",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1155",
  "onboarding-tours": "/onboarding-tours/static-1.16929",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14186",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2279",
  "trellis-components": "/trellis-components/static-1.2298",
  "trellis-theming": "/trellis-theming/static-1.1120",
  "ui-addon-teams": "/ui-addon-teams/static-1.21766",
  "quartz-auth": "/quartz-auth/static-1.932",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9251",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5210",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9396",
  "ContentUtils": "/ContentUtils/static-1.68882",
  "customer-data-properties": "/customer-data-properties/static-1.52168",
  "forms-ai-lib": "/forms-ai-lib/static-1.4586",
  "forms-utils-lib": "/forms-utils-lib/static-1.12901",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5754",
  "react-dnd-compat": "/react-dnd-compat/static-1.4786",
  "react-tinymce": "/react-tinymce/static-1.55713",
  "tinymce-config": "/tinymce-config/static-2.54839",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10521",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3596",
  "HeadJS": "/HeadJS/static-2.777",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3305",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.205",
  "ui-fonts": "/ui-fonts/static-1.911",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4496",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.922",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1716",
  "external-options-client-types": "/external-options-client-types/static-1.4250",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.932",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8099",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3873",
  "reporting-client-types": "/reporting-client-types/static-1.2600",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25906",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5050",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1296",
  "quartz-routing": "/quartz-routing/static-1.687",
  "hs-story-utils": "/hs-story-utils/static-1.9597",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.409",
  "timezone-utils": "/timezone-utils/static-2.5415",
  "seat-types-lib": "/seat-types-lib/static-1.407",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4540",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.932",
  "quartz-tracking": "/quartz-tracking/static-1.636",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.240",
  "chirp-fetch": "/chirp-fetch/static-1.2060",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6168",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4204",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3094",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1358",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.350",
  "pulse": "/pulse/static-1.785",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3921",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4262",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.185",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3816",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18931",
  "growth-data-modal": "/growth-data-modal/static-1.5713",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3236",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2431",
  "navigation-components": "/navigation-components/static-1.18492",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5143",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.995",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10434",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7815",
  "ui-universal-auth": "/ui-universal-auth/static-1.9182",
  "user-context": "/user-context/static-1.5282",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10391",
  "magpie-lib": "/magpie-lib/static-1.5666",
  "navigation-messaging": "/navigation-messaging/static-1.7819",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22179",
  "copilot-toolkit": "/copilot-toolkit/static-1.11581",
  "cms-field-types": "/cms-field-types/static-1.4987",
  "content-icons-ui": "/content-icons-ui/static-1.2278",
  "integrations-lib": "/integrations-lib/static-1.16713",
  "calling-global-api": "/calling-global-api/static-1.65104",
  "calling-internal-common": "/calling-internal-common/static-1.31485",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66486",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58780",
  "commerce-products-lib": "/commerce-products-lib/static-1.10212",
  "crm-links": "/crm-links/static-1.6486",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9720",
  "file-manager-components": "/file-manager-components/static-1.24135",
  "formula-editor": "/formula-editor/static-1.14563",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4341",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.804",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49315",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4091",
  "property-value-citations": "/property-value-citations/static-1.2782",
  "smart-property-lib": "/smart-property-lib/static-1.8052",
  "tiered-pricing": "/tiered-pricing/static-1.1708",
  "topics-actions-lib": "/topics-actions-lib/static-1.320",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9248",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20132",
  "tinymce-themes": "/tinymce-themes/static-1.56809",
  "data-token-picker": "/data-token-picker/static-1.16714",
  "hub-http-contrib": "/hub-http-contrib/static-1.3215",
  "interframe": "/interframe/static-3.4927",
  "tinymce-data": "/tinymce-data/static-1.40924",
  "tinymce-plugins": "/tinymce-plugins/static-1.57953",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5384",
  "onboarding-scopes": "/onboarding-scopes/static-1.6630",
  "ui-addon-opt": "/ui-addon-opt/static-4.8533",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4823",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.509",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.345",
  "purchase-motions-api": "/purchase-motions-api/static-1.6171",
  "event-emitter": "/event-emitter/static-1.1121",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.288",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2261",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2459",
  "user-context-client": "/user-context-client/static-1.4722",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5126",
  "nest": "/nest/static-1.406",
  "reactive-lib": "/reactive-lib/static-1.896",
  "simple-logging-lib": "/simple-logging-lib/static-1.3221",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.978",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18049",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1339",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14128",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5778",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7952",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10536",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.696",
  "calling-error-reporting": "/calling-error-reporting/static-1.31492",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11208",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6713",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1626",
  "customer-data-tracking": "/customer-data-tracking/static-1.7057",
  "commerce-permissions": "/commerce-permissions/static-1.947",
  "products-iframe-lib": "/products-iframe-lib/static-1.8355",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10775",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9773",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4320",
  "video-components-external": "/video-components-external/static-1.11855",
  "video-data-lib": "/video-data-lib/static-1.35513",
  "bark-lib": "/bark-lib/static-1.16654",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6059",
  "react-codemirror": "/react-codemirror/static-1.10804",
  "data-agent-kit": "/data-agent-kit/static-1.469",
  "feedback-loader": "/feedback-loader/static-1.29621",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10476",
  "fsm": "/fsm/static-1.3901",
  "policy-lib": "/policy-lib/static-1.6957",
  "react-colorpicker": "/react-colorpicker/static-2.10379",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10539",
  "FileManagerLib": "/FileManagerLib/static-1.39775",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9175",
  "FileManagerCore": "/FileManagerCore/static-1.39634",
  "content-assistance-lib": "/content-assistance-lib/static-1.8020",
  "layout-dnd-components": "/layout-dnd-components/static-1.12779",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11754",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10056",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15922",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15286",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7779",
  "breeze-engine-core": "/breeze-engine-core/static-1.617",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3184",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.194",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.682",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.759",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.210",
  "slack-ui-library": "/slack-ui-library/static-1.10569",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36403",
  "sales-views-client-types": "/sales-views-client-types/static-1.4430",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3709",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12883",
  "content-media-compositions": "/content-media-compositions/static-2.16890",
  "media-bridge-lib": "/media-bridge-lib/static-1.19229",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16085",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4679",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6176",
  "FileManagerImages": "/FileManagerImages/static-1.37286",
  "video-components": "/video-components/static-1.13857",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4704",
  "video-embed": "/video-embed/static-1.36347",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8877",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29051",
  "ContentData": "/ContentData/static-1.68957",
  "layout-data-lib": "/layout-data-lib/static-1.10079",
  "social-insights-client-types": "/social-insights-client-types/static-1.22538",
  "outpost": "/outpost/static-1.4340",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6751",
  "advanced-menus-core": "/advanced-menus-core/static-1.15416",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12313",
  "ExportDialog": "/ExportDialog/static-6.10550",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34526",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15415",
  "simple-menus-lib": "/simple-menus-lib/static-1.16932"
}
};
